import {getFullContent} from '@api/preview';
import ButtonFill from '@components/ButtonFill';
import Link from '@components/Link';
import Preview from '@components/Preview';
import {useCurrentUserContext} from '@context/CurrentUserContext';
import type {ReactElement} from 'react';
import {useEffect, useRef, useState} from 'react';
import {isElementInViewport} from '@utils/positionUtils';
import throttle from 'lodash.throttle';
import Analytics from '@services/analytics/Analytics';

interface Props {
    title: string;
    text: string;
}

const THROTTLING_INTERVAL = 300;

export default function Club(props: Props): ReactElement<Props> {
    const currentUserState = useCurrentUserContext();
    const [hasPreviewShown, setHasPreviewShown] = useState(false);
    const previewRef = useRef<HTMLDivElement>(null);

    const handleScroll = throttle(() => {
        const preview = previewRef.current?.getBoundingClientRect();
        if (preview) {
            const isPreviewReached = isElementInViewport(document, preview.top, preview.height);
            if (!hasPreviewShown && isPreviewReached) {
                Analytics.triggerEvent('Paywall появился на экране', 'scroll');
                setHasPreviewShown(true);
            }
        }
    }, THROTTLING_INTERVAL);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hasPreviewShown]);

    return (
        <Preview getFullContent={getFullContent}>
            {() => (
                <div className="club-member-preview" ref={previewRef}>
                    <div className="club-member-preview__divider" />
                    <div className="club-member-preview__content">
                        <h4>{props.title}</h4>
                        <p>{props.text}</p>
                        {currentUserState.isRetrieved && !currentUserState.isLoggedIn ? (
                            <p>
                                Присоединяйтесь или{' '}
                                <Link
                                    className="js-track-paywall-log-in"
                                    to={`/wp-login.php?redirect_to=${encodeURIComponent(
                                        location.href,
                                    )}`}
                                >
                                    войдите
                                </Link>{' '}
                                в свой аккаунт, если вы уже с нами 💚
                            </p>
                        ) : null}
                        <Link
                            to="/club/"
                            className="club-member-preview__button js-track-paywall-join-club"
                        >
                            <ButtonFill type="button">Присоединиться</ButtonFill>
                        </Link>
                    </div>
                </div>
            )}
        </Preview>
    );
}
